export default __webpack_public_path__ + "static/media/liberum-5.2ca357b6.png";